import {ENoteCategory} from '@/types/airport';
import moment from 'moment';

export const mapAirportNoteFleetName = (fleetName: string): string => {
  if (fleetName === 'A319_A320_A321') {
    return 'A320';
  }
  return fleetName;
};

export const airportNoteCategoryTitle = (category: ENoteCategory) => {
  switch (category) {
    case ENoteCategory.ARRIVAL:
      return 'Arrival';
    case ENoteCategory.DEPARTURE:
      return 'Departure';
    case ENoteCategory.GROUND_OPERATIONS:
      return 'Ground Operations';
    case ENoteCategory.CAUTION:
      return 'Threats';
    case ENoteCategory.RESTRICTIONS:
      return 'Company requirements';
    case ENoteCategory.FLEET_INFORMATION:
      return 'Fleet specific info';
  }
};

export const airportNoteSubCategoryTitle = (category: ENoteCategory) => {
  switch (category) {
    case ENoteCategory.ARRIVAL:
      return 'procedural notes';
    case ENoteCategory.DEPARTURE:
      return 'procedural notes';
    case ENoteCategory.GROUND_OPERATIONS:
      return 'procedural notes';
    case ENoteCategory.CAUTION:
      return 'procedural notes';
    case ENoteCategory.RESTRICTIONS:
      return 'GENERAL RESTRICTIONS AND REQUIREMENTS';
    case ENoteCategory.FLEET_INFORMATION:
      return 'Fleet specific info';
  }
};

export const airportNoteFleetTitle = (
  fleet: string,
  category: ENoteCategory
) => {
  switch (category) {
    case ENoteCategory.ARRIVAL:
      return `${fleet} ARRIVAL`;
    case ENoteCategory.DEPARTURE:
      return `${fleet} DEPARTURE`;
    case ENoteCategory.GROUND_OPERATIONS:
      return `${fleet} GROUND OPERATIONS`;
    case ENoteCategory.CAUTION:
      return `${fleet} CAUTION`;
    case ENoteCategory.RESTRICTIONS:
      return `${fleet} RESTRICTIONS AND REQUIREMENTS`;
  }
};

export const airportNotePublishedFormatted = (
  publishedAt: string,
  isPending: boolean,
  author: string
) => {
  const time = moment(publishedAt).format('DD/MM/YY HH:mm');
  if (isPending) {
    return `Shared by ${author} at ${time}`;
  }
  if (author !== 'Admin') {
    return `Published by Admin at ${time}   Based on contribution by ${author}`;
  }
  return `Published by Admin at ${time}`;
};

// 'CAT_1' --> CAT I
// 'CAT_2' --> CAT II
// 'CAT_3' --> CAT III
// 'NON_PRECISION' --> NON-PRECISION
export const airportNoteCatTitle = (cat: string) => {
  switch (cat) {
    case 'CAT_1':
      return 'CAT I';
    case 'CAT_2':
      return 'CAT II';
    case 'CAT_3':
      return 'CAT III';
    case 'NON_PRECISION':
      return 'NON-PRECISION';
    default:
      return cat;
  }
};
